export enum BadgeColorsEnum {
  DARK = 'DARK',
  GREEN15 = 'GREEN15',
  GREY20 = 'GREY20',
  PRIMARY = 'PRIMARY',
  RED = 'RED',
  RED20 = 'RED20',
  SELECT = 'SELECT',
  TRANSPARENT = 'TRANSPARENT'
}

export enum BadgeSizesEnum {
  SMALL = 'SMALL',
  MEDIUM = 'MEDIUM',
  LARGE = 'LARGE'
}
